<template>

  <div>
    <div>
      <vxe-form :data="toolbar.formData">
        <vxe-form-item title="关键字" field="searchKey" :item-render="{}">
          <template #default="{ data }">
            <vxe-input v-model="data.searchKey" placeholder="请输入编号或名称"></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item>
          <template #default>
            <vxe-button status="primary" @click="findData" @keyup.enter="findData">查询</vxe-button>
            <vxe-button @click="clear">重置</vxe-button>
            <vxe-button status="success" @click="add">新增</vxe-button>
          </template>
        </vxe-form-item>
      </vxe-form>
    </div>
    <div style="overflow: hidden;height: 100%">
      <vxe-table
          stripe
          class="mytable-scrollbar"
          ref="table"
          :data="tableData"
          :height="tableHeight"
          show-overflow
          :row-config="{height: 36,isHover: true,isCurrent:true}"
      >
        <vxe-column type="seq" field="id" title="序号" width="60"></vxe-column>
        <vxe-column title="删除" width="50" show-overflow>
          <template #default="{ row }">
            <vxe-button type="text" icon="fa fa-trash-o" @click="removeRow(row)"></vxe-button>
          </template>
        </vxe-column>
        <vxe-column title="编辑" width="50" show-overflow>
          <template #default="{ row }">
            <vxe-button type="text" icon="fa fa-edit" @click="editRow(row)"></vxe-button>
          </template>
        </vxe-column>
        <vxe-column field="code" title="部署平台编号" width="200" sortable show-overflow></vxe-column>
        <vxe-column field="name" title="部署平台名称" width="200" sortable show-overflow></vxe-column>
        <vxe-column field="creatorName" title="创建人" width="100" sortable show-overflow></vxe-column>
        <vxe-column field="creationTime" title="创建时间" width="160"  sortable show-overflow></vxe-column>

      </vxe-table>
    </div>
    <div>
      <vxe-pager
          background
          v-model:current-page="tablePager.currentPage"
          v-model:page-size="tablePager.pageSize"
          :total="tablePager.totalResult"
          @page-change="handlePageChange"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']">
      </vxe-pager>
    </div>
  </div>
  <vxe-modal
      v-model="formInput.isShow"
      width="600"
      height="250"
      @close="findData"
      :title="formInput.title"
      show-zoom resize remember
  >
    <template #default>
      <div>
        <vxe-form
            :data="formInput.formData"
            :rules="formInput.formRules"
            ref="nForm"
        >
          <vxe-form-item title="部署平台编号" field="code" span="24" :item-render="{}" title-width="160px">
            <template #default="{ data }">
              <vxe-input v-model="data.code" placeholder="请输入部署平台编号" clearable></vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item title="部署平台名称" field="name" span="24" :item-render="{}" title-width="160px">
            <template #default="{ data }">
              <vxe-input v-model="data.name" placeholder="请输入部署平台名称" clearable></vxe-input>
            </template>
          </vxe-form-item>

          <vxe-form-item align="center" span="24">
            <template #default>
              <vxe-button @click="save" icon="fa fa-save" status="success">保存
              </vxe-button>

            </template>
          </vxe-form-item>
        </vxe-form>
      </div>

    </template>
  </vxe-modal>

</template>

<script>

import Qs from 'qs'
import {reactive} from 'vue';
import {VXETable} from 'vxe-table'


export default {
  name: "DeployPlatform",
  components: {},
  data() {
    const pageHeight = window.innerHeight - (65 + 48 + 198) + 'px';//屏幕高度减去导航栏和内补白
    const tablePager = reactive({
      currentPage: 1,
      pageSize: 10,
      totalResult: 0
    })
    const toolbar = reactive({
      loading: false,
      formData: {
        searchKey: ''
      }
    })


    const formInput = reactive({
      isShow: false,
      editType: '1',
      title: '新增部署平台',
      formData: {
        id: '',
        code: '',
        name: ''


      }, formRules: {
        code: [
          {required: true, message: '部署平台编号不能为空'},
        ],
        name: [
          {required: true, message: '部署平台名称不能为空'}]
      }
    })

    return {
      tableData: null,
      tablePager,
      toolbar,
      formInput,
      pageHeight,
      tableHeight: 0
    }
  },
  methods: {
    add() {
      this.formInput.isShow = true;
      this.formInput.editType = '1';
      this.formInput.title = '新增部署平台';
      this.formInput.formData = {
        id: '',
        code: '',
        name: '',
        creator: this.getUserId,
        modifier: this.getUserId
      };
    },
    editRow(row) {
      const params = {
        'uid': this.getUserId,
        'email': this.getUserEmail,
        'currentPage': 1,
        'pageSize': 20,
        'searchKey': [row.id]
      };
      this.formInput.isShow = true;

      this.$api.digitalDictManageAPI.getDeployPlatformOne(Qs.stringify(params))
          .then(res => {
            if (res.data.Success == false) {
              VXETable.modal.message({content: res.data.Message, status: 'error'});
              return;
            }
            this.formInput.isShow = true;
            this.formInput.formData.id = res.data.Data.dataTable[0].id;
            this.formInput.formData.code = res.data.Data.dataTable[0].code;
            this.formInput.formData.name = res.data.Data.dataTable[0].name;
            this.formInput.title = '编辑部署平台'
            this.formInput.editType = '2';//更新
          })
          .catch(error => {
            console.log(error);

          })
    },
    async removeRow(row) {
      const type = await VXETable.modal.confirm('您确定要删除该数据?')
      const $grid = this.$refs.table;

      if (type === 'confirm') {

        this.$api.digitalDictManageAPI.deleteDeployPlatform(Qs.stringify({"hqId": row.id}))
            .then(res => {
              if (res.data.Success === false) {
                VXETable.modal.message({content: res.data.Message, status: 'error'});
                return;
              }
              VXETable.modal.message({content: "删除成功", status: 'success'});
              $grid.remove(row);
            })
            .catch(error => {
              console.log(error);
            })
      }

    },
    async save() {
      const $rForm = this.$refs.nForm;
      const formErrMap = await $rForm.validate();
      if (formErrMap) {
        return;
      }
      const params = this.formInput.formData;

      //新增
      if (this.formInput.editType === '1') {
        this.$api.digitalDictManageAPI.addDeployPlatform(Qs.stringify(params))
            .then(res => {
              if (res.data.Success == false) {
                VXETable.modal.message({content: res.data.Message, status: 'error'});
                return;
              }
              VXETable.modal.message({content: '保存成功', status: 'success'});
              this.formInput.isShow = false;
              this.findData();
            })
            .catch(error => {
              VXETable.modal.alert({content: error, status: 'error'});
              console.log(error);
            });
      } else if (this.formInput.editType === '2') { //更新
        this.$api.digitalDictManageAPI.updateDeployPlatform(Qs.stringify(params))
            .then(res => {
              if (res.data.Success == false) {
                VXETable.modal.message({content: res.data.Message, status: 'error'});
                return;
              }
              VXETable.modal.message({content: '保存成功', status: 'success'});
              this.formInput.isShow = false;
              this.findData();
            })
            .catch(error => {
              VXETable.modal.message({content: error, status: 'error'});
              console.log(error);
            });
      }
    },
    calTableHeight(rowsLength) {
      let minHeight = window.innerHeight - (65 + 28 + 198);
      let calHeight = rowsLength == null ? 0 : (rowsLength + 1) * 36 + 22;
      this.tableHeight = Math.max(minHeight, calHeight);
    },
    findData() {
      const params = {
        'uid': this.$store.state.userID,
        'email': this.$store.state.email,
        'currentPage': this.tablePager.currentPage,
        'pageSize': this.tablePager.pageSize,
        'searchKey': [this.toolbar.formData.searchKey]
      };
      this.$api.digitalDictManageAPI.getDeployPlatformList(Qs.stringify(params))
          .then(res => {
            if (res.data.Success == false) {
              VXETable.modal.message({content: res.data.Message, status: 'error'});

              return;
            }
            // console.log(res.data.Data);
            this.tableData = res.data.Data.dataTable;
            this.tablePager.currentPage = res.data.Data.currentPage;
            this.tablePager.pageSize = res.data.Data.pageSize;
            this.tablePager.totalResult = res.data.Data.totalResult;
            this.tableHeight = this.$calTableHeight(res.data.Data.dataTable.length);

          })
          .catch(error => {
            console.log(error);

          })
    },
    handlePageChange() {
      this.findData();
    },
    clear() {
      this.toolbar.formData.searchKey = ''
    },
    keydown(e) {
      if (e.keyCode === 13) {
        this.findData();
      }
    },
  },
  mounted() {
    this.findData();
    this.formInput.formData.creator = this.getUserId;
    this.formInput.formData.modifier = this.getUserId;
    window.addEventListener("keydown", this.keydown)
  },
  unmounted() {
    window.removeEventListener("keydown", this.keydown, false);
  },
  computed: {
    getUserName() {
      return this.$store.state.userName;
    },
    getJobZb() {
      return this.$store.state.jobZb;
    },
    getJobName() {
      return this.$store.state.jobName;
    },
    getUserEmail() {
      return this.$store.state.email;
    },
    getUserId() {
      return this.$store.state.userID;
    }
  }
}

</script>


<style type="text/css">
td.vxe-body--column {
  vertical-align: middle;
}
</style>
